import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UploadAssetsEventsComponent } from '../../components/upload-assets-events/upload-assets-events.component';
import { EventService } from '../..';
import { DEFAULT_SNACKBAR_CONFIG, Logger, OrganizationService } from 'src/app/@shared';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CloneType } from '../../models/clone-type.model';
import { OfferPromoService } from '../../services/offerpromo.service';
import { finalize } from 'rxjs';
import { Router } from '@angular/router';
interface DialogData {
  eventId: string;
}
const log = new Logger('CloneVersionsComponent');
@Component({
  selector: 'app-clone-versions',
  templateUrl: './clone-versions.component.html',
  styleUrls: ['./clone-versions.component.scss'],
})
export class CloneVersionsComponent implements OnInit {
  cloneForm: FormGroup = new FormGroup({
    sourceEvent: new FormControl(null, [Validators.required]),
    destinationEvent: new FormControl(null, [Validators.required]),
    versions: new FormControl([]),
  });
  sourceEventId: string = '';
  destinationEventId: string = '';
  CloneType = CloneType;
  versionList: any[] = [];
  isLoading: boolean = false;
 
  constructor(
    private dialog: MatDialog,
    private eventService: EventService<any>,
    private matSnackBar: MatSnackBar,
    private organizationService: OrganizationService,
    private offerpromoService: OfferPromoService<any, any>,
    public dialogRef: MatDialogRef<CloneVersionsComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.sourceEventId = this.data.eventId;
    this.destinationEventId = this.data.eventId;
    this.offerpromoService.cloneEventId = this.data.eventId;
    this.eventService.getEvent(this.sourceEventId).subscribe((res) => {
      this.cloneForm.controls['sourceEvent'].setValue(res.EventName);
      this.cloneForm.controls['destinationEvent'].setValue(res.EventName);
    });

  }
  ngOnInit(): void {
    log.debug('init');
  }

  openSourceEventsDialog() {
    const dialogRef = this.dialog.open(UploadAssetsEventsComponent, {
      width: '60%',
      height: '90%',
      data: { includeExpiredEvents: true },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.cloneForm.controls['sourceEvent'].patchValue(res.Detail?.EventName);
        this.sourceEventId = res.Detail?.Id;
        this.offerpromoService.cloneEventId = res.Detail?.Id;
      }
    });
  }

  openDestinationEventsDialog() {
    const dialogRef = this.dialog.open(UploadAssetsEventsComponent, {
      width: '60%',
      height: '90%',
      data: { includeExpiredEvents: true },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.cloneForm.controls['destinationEvent'].patchValue(res.Detail?.EventName);
        this.destinationEventId = res.Detail?.Id;
      }
    });
  }
  get sameEventSelected(): boolean {
    return this.sourceEventId === this.destinationEventId;
  }

  cloneVersions() {
    if (this.cloneForm.invalid) {
      return;
    }
    if (this.sameEventSelected) {
      this.matSnackBar.open('Source and Destination cannot be the same', 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
      return;
    }

    this.isLoading = true;

    this.eventService.cloneVersionAndStores(this.sourceEventId, this.destinationEventId)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          this.matSnackBar.open(`Version(s) and stores cloned successfully`, 'OK', DEFAULT_SNACKBAR_CONFIG);
          this.dialogRef.close();
          const url = (`${this.organizationService.organization?.apiPath}`).toLowerCase();
          let currentUrl = `${url}/events/${this.destinationEventId}/versions`;
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl]);
          });
        },
        error: (error) => {
          if (error.status === 500) {
            log.error('500 Error cloning offers/promos', error);
            this.matSnackBar.open('500 Error cloning offers/promos', 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
          }
          else if (error.status === 400) {
            const apiValidations = error.error;

            if (Array.isArray(apiValidations) && typeof apiValidations[0] === 'string') {
              this.matSnackBar.open(apiValidations[0], 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
              return;
            }

            if (Array.isArray(apiValidations)) {
              const errorMessages: string[] = [];
              apiValidations.forEach((validation: any) => {
                if (!validation?.PropertyName) {
                  errorMessages.push(validation?.ErrorMessage);
                  return;
                }
                const controlPath = validation.PropertyName;
                const control = this.cloneForm?.get(controlPath);
                if (control) {
                  control.markAsTouched();
                  control.setErrors({
                    ...(control.errors || {}),
                    apiError: validation.ErrorMessage
                  });
                } else {
                  errorMessages.push(validation.ErrorMessage);
                }
              });

              if (errorMessages.length > 0) {
                this.matSnackBar.open(errorMessages[0], 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
              }
              this.cloneForm.updateValueAndValidity();
            }
            else if (apiValidations?.error?.message) {
              this.matSnackBar.open(apiValidations.error.message, 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
            }
            else if (apiValidations?.message) {
              this.matSnackBar.open(apiValidations.message, 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
            }
            else if (typeof apiValidations === 'string') {
              this.matSnackBar.open(apiValidations, 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
            }
            else {
              this.matSnackBar.open(typeof apiValidations === 'object' && apiValidations?.Message ? apiValidations.Message : apiValidations, 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
            }
          }
          else if (error.status === 429) {
            this.matSnackBar.open(`Too many requests. Please wait a moment and retry. (statusCode; ${error.status})`, 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
          }
          else if (error.status === 504 || error.status === 408) {
            this.matSnackBar.open(`Server is taking too long to respond. Please try again. (statusCode; ${error.status})`, 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
          }
          else if (error.status === 0) {
            this.matSnackBar.open(`Request timed out or network issue. Check your connection. (statusCode; ${error.status})`, 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
          }
          else {
            const message = error?.error?.message || error?.message || `Unexpected error. (statusCode; ${error.status})`;
            this.matSnackBar.open(message, 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
          }
        }
      });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
